import { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { FaFacebookF } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { BsGlobe } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Register from "../Register/Register";
import Tabs from "react-bootstrap/Tabs";
import Login from "../Form/Login";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Actions } from "../../redux/Actions/Actions";
import { FaPowerOff } from "react-icons/fa";
import { endPoints, Image_Url } from "../../Constant/Environment";
import maleUserImage from "../../Assets/Images/male-user.png";
import { getAllItemsData } from "../../Utility/Api";
import femaleImage from "../../Assets/Images/female.png";
import Forgot from "../Forgot/Forgot";
import { useModal } from '../../ModalContext';
import { Button } from "react-bootstrap";

function Header() {
  const { handleFirstModalOpen} = useModal();
  

  const [isActive, setIsActive] = useState(false);
  const { isAuthenticated, traveler, sender, user } = useSelector(
    (state) => state.auth
  );
  const { contactData } = useSelector((state) => state.contactData);
  // console.log(contactData);
  var profilepic = "";
  var fullname = "";

  if (user && Object.keys(user).length !== 0) {
    const { first_name, image, gender } = user;
    if (first_name) {
      profilepic = !image
        ? gender === "male"
          ? maleUserImage
          : femaleImage
        : Image_Url + image.replace(/\\/g, "/");
      fullname = `${first_name.charAt(0)}`.toUpperCase();
    }
  }
  let navigate = useNavigate();
  const dispatch = useDispatch();
  function Logout() {
    dispatch({
      type: Actions.USERLOGOUT,
    });
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }

  useEffect(() => {
    let url = `${endPoints.api.CONTACT_PAGE_DATA}`;
    getAllItemsData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          // console.log(data);
          dispatch({
            type: Actions.CONTACT_DATA,
            data: { contactData: data },
          });
        } else {
          // Handle error or show a message
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const handleClick = () => {
    const navbarCollapseElement = document.querySelector('.navbar-toggler');
    const navbarScrollElement = document.getElementById('navbarScroll');
    if (navbarScrollElement) {
      navbarScrollElement.classList.remove('show');
      navbarCollapseElement.classList.add('collapsed');
    }
  };
  // const [showFirstModal, setShowFirstModal] = useState(false);
  // const [showSecondModal, setShowSecondModal] = useState(false);
  // const [showThirdModal, setShowThirdModal] = useState(false);

  // const handleFirstModalOpen = () => {
  //   setShowFirstModal(true);
  //   setShowThirdModal(false);
  // };

  // const handleFirstModalClose = () => setShowFirstModal(false);
  // const handleThirdModalClose = () => setShowThirdModal(false);
  // const handleSecondModalClose = () => setShowSecondModal(false);

  // const handleSecondModalOpen = () => {
  //   setShowFirstModal(false);
  //   setShowSecondModal(true);
  // };

  // const handleThirdModalOpen = () => {
  //   setShowThirdModal(true);
  //   setShowFirstModal(false);
  // };

  return (
    <>
      <header>
        <div className="top-header">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="mobile-hide">
                  <NavLink exact to="/">
                    {contactData && contactData.logo ? (
                      <img
                        src={Image_Url + contactData.logo}
                        className="kri-logo img-fluid pt-2"
                        alt="logo"
                      />
                    ) : null}
                  </NavLink>
                </div>
              </div>
              <div className="col-md-9 d-flex align-items-center justify-content-end">
                <div className="top-nav-right d-none d-md-block">
                  <ul>
                    <li className="mobile-hide1">Follow Us:</li>
                    <li>
                      <Link
                        to={contactData ? contactData.fb_link : ""}
                        className="facebook"
                        target="_blank"
                        aria-label="facebook"
                      >
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={contactData ? contactData.twitter_link : ""}
                        className="facebook"
                        target="_blank"
                        aria-label="facebook"
                      >
                        <FaXTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={contactData ? contactData.linkedin_link : ""}
                        className="facebook"
                        target="_blank"
                        aria-label="facebook"
                      >
                        <FaLinkedinIn />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={contactData ? contactData.insta_link : ""}
                        className="facebook"
                        target="_blank"
                        aria-label="facebook"
                      >
                        <FaInstagram />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={contactData ? contactData.youtube_link : ""}
                        className="facebook"
                        target="_blank"
                        aria-label="facebook"
                      >
                        <FaYoutube />
                      </Link>
                    </li>
                    {/* <li>
                      <select
                        onchange="doGTranslate(this);"
                        class="gtranslate_mobile notranslate"
                        id="gtranslate_selector"
                        aria-label="Website Language Selector"
                      >
                        <option value="">Select Language</option>
                        <option selected value="en|en">
                          English
                        </option>
                        <option value="es">Spanish</option>
                        <option value="fr">French</option>
                        <option value="de">German</option>
                        <option value="zh">Chinese</option>

                        <option value="en|hi">Hindi</option>
                        <option value="en|mr">Marathi</option>
                        <option value="en|kn">Kannada </option>
                      </select>
                    </li> */}
                    <li>
                      <BsGlobe />
                    </li>
                    {!isAuthenticated && (
                      <Button
                        
                        className="white-btn c-btn"
                        onClick={handleFirstModalOpen}
                      >
                        <img
                          src={require("../../Assets/Images/login.webp")}
                          alt="logo1"
                        />
                        Login / Register
                      </Button>
                    )}
                    {isAuthenticated && (
                      <Nav className="ms-auto">
                        <a style={{ cursor: "pointer", color: "#FEEAA6" }}>
                          <FaPowerOff size={20} onClick={Logout} />
                        </a>
                      </Nav>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="kri-nav mt-3">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="mobile-header">
                  <div className="m-show">
                    <NavLink exact to="/" onClick={scrollToTop}>
                      <img
                        src={require("../../Assets/Images/SS-Logo.webp")}
                        className="kri-logo img-fluid pt-2"
                        alt="logo"
                      />
                    </NavLink>
                  </div>
                  <Navbar expand="lg">
                    <Container fluid>
                      <Navbar.Toggle aria-controls="navbarScroll" />
                      <Navbar.Collapse id="navbarScroll"  >
                        <Nav navbarScroll>
                          <NavLink
                            className="nav-link"
                            to="/"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            Welcome
                          </NavLink>
                          <NavLink
                            className="nav-link"
                            to="/sender"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            {" "}
                            For Sender
                          </NavLink>
                          <NavLink
                            className="nav-link"
                            to="/traveler"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            {" "}
                            For Traveler
                          </NavLink>
                          <NavLink
                            className="nav-link"
                            to="/how-it-works"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            How it Works
                          </NavLink>
                          <NavLink
                            className="nav-link"
                            to="/about-us"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            About Us
                          </NavLink>
                          <NavLink
                            className="nav-link"
                            to="/help"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            Help
                          </NavLink>
                          <NavLink
                            className="nav-link"
                            to="/contact-us"
                            onClick={() => { scrollToTop(); handleClick(); }}
                          >
                            Contact Us
                          </NavLink>
                          {isAuthenticated &&
                            profilepic &&
                            profilepic !== "" && (
                              <div className="user-profile">
                                <Link to="dashboard">
                                  <img src={profilepic} alt="logo1" />
                                  {fullname}
                                </Link>
                              </div>
                            )}
                          <div className="kri-topbar-right d-block d-md-none mobile-set">
                            <ul className="ul-set">
                              <li className="mobile-hide1">Follow Us:</li>
                              <li>
                                <Link
                                  to={contactData ? contactData.fb_link : ""}
                                  className="facebook"
                                  target="_blank"
                                  aria-label="facebook"
                                >
                                  <FaFacebookF />
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={
                                    contactData ? contactData.twitter_link : ""
                                  }
                                  className="facebook"
                                  target="_blank"
                                  aria-label="facebook"
                                >
                                  <FaXTwitter />
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={
                                    contactData ? contactData.linkedin_link : ""
                                  }
                                  className="facebook"
                                  target="_blank"
                                  aria-label="facebook"
                                >
                                  <FaLinkedinIn />
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={contactData ? contactData.insta_link : ""}
                                  className="facebook"
                                  target="_blank"
                                  aria-label="facebook"
                                >
                                  <FaInstagram />
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={
                                    contactData ? contactData.youtube_link : ""
                                  }
                                  className="facebook"
                                  target="_blank"
                                  aria-label="facebook"
                                >
                                  <FaYoutube />
                                </Link>
                              </li>
                              <li>
                                <BsGlobe />
                                <select>
                                  <option>EN</option>
                                  <option>EN</option>
                                  <option>EN</option>
                                  <option>EN</option>
                                  <option>EN</option>
                                </select>
                              </li>
                            </ul>
                            {!isAuthenticated && (
                              <Link
                                to="/"
                                className="white-btn c-btn"
                                onClick={handleFirstModalOpen}
                              >
                                <img
                                  src={require("../../Assets/Images/login.webp")}
                                  alt="logo1"
                                />
                                Login / Register
                              </Link>
                            )}
                            {isAuthenticated && (
                              <Nav className="ms-auto">
                                <a style={{ cursor: "pointer", color: "#FEEAA6" }}>
                                  <FaPowerOff size={20} onClick={Logout} />
                                </a>
                              </Nav>
                            )}
                          </div>
                        </Nav>
                      </Navbar.Collapse>
                    </Container>
                  </Navbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      
    </>
  );
}

export default Header;
